import { TSliderPicture } from '@/domain/Images.domain';
import { cn } from '@/service/utils/cn';

const EMPTY_IMG = '/img/EmptyImage.svg';

export const SliderPicture = ({ srcSet, slug, className, onClick }: TSliderPicture) => {
    return (
        <picture
            className={cn(`slider-item block h-full w-full min-w-full`, className)}
            data-test-id="slider-picture"
            onClick={onClick}
        >
            {srcSet.map(({ src, media, mediaType }) => (
                <source key={src} srcSet={src} media={media} type={mediaType} />
            ))}

            <img
                src={srcSet[srcSet.length - 1].src}
                alt={slug || srcSet[0].mediaType}
                className="h-full w-full object-cover"
                onError={({ target }) => {
                    const e = target as HTMLImageElement;
                    e.onerror = null;
                    if (e.parentNode) {
                        Array.from(e.parentNode.children).forEach((element) => {
                            (element as HTMLImageElement).srcset = EMPTY_IMG;
                        });
                    }
                    e.src = EMPTY_IMG;
                }}
            />
        </picture>
    );
};
